import { Stack, TextField, Typography } from "@mui/material";
import { Component } from "react";

export default class ValorInput extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    formatCurrency(value) {
        if (!value) return "";
        const numericValue = value.replace(/[^0-9]/g, "");
        const formattedValue = (Number(numericValue) / 100).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
        return formattedValue;
    }

    handleChange(event) {
        const formattedValue = this.formatCurrency(event.target.value);
        if (this.props.onChange) {
            this.props.onChange(formattedValue);
        }
    }

    render() {
        return (
            <Stack sx={{ ...this.props.sx }}>
                <TextField
                    {...this.props.props}
                    autoComplete="off"
                    onClick={() => this.props.onClick ? this.props.onClick() : {}}
                    sx={this.props.sx}
                    inputProps={{ maxLength: 14 }}
                    error={this.props.error === true}
                    size="small"
                    variant="outlined"
                    name="valor"
                    value={this.props.value}
                    onChange={this.handleChange}
                    label={'Valor' + (this.props.required ? '*': '')}
                />
            </Stack>
        );
    }
}
